export enum BinanceLedgerSubType {
  DEPOSIT = 'DEPOSIT',
  FIAT_DEPOSIT_WITHDRAW = 'FIAT_DEPOSIT_WITHDRAW',
  WITHDRAW = 'WITHDRAW',
  UNIVERSAL_TRANSFER = 'UNIVERSAL_TRANSFER',
  SUB_ACCOUNT_TRANSFER = 'SUB_ACCOUNT_TRANSFER'
}
